import { GrowCheckBox, GrowCheckBoxGroup } from "@sinecycle/growcomponents";

function AntCheckBox(props: React.ComponentProps<typeof GrowCheckBox>) {
  return <GrowCheckBox {...props} />;
}
function AntCheckBoxGroup(
  props: React.ComponentProps<typeof GrowCheckBoxGroup>
) {
  return <GrowCheckBoxGroup {...props} />;
}
export { AntCheckBox as CheckBox, AntCheckBoxGroup as CheckBoxGroup };
